import { Resource as e } from "@coveo/platform-client";
//#region src/resources/SalesforceSourceConfigurationInternalResource.ts
var t = class t extends e {
	static {
		this.baseUrl = "/rest/sourceconfiguration/salesforce/objects";
	}
	async objects(e) {
		let n = await this.api.get(this.buildPath(t.baseUrl, {
			refreshTokenGuid: e,
			serviceCloudIndexed: !0,
			knowledgeIndexed: !0
		}));
		return this.objectsAndFieldsSorter(n);
	}
	async objectFields(e, n) {
		let r = await this.api.get(this.buildPath(`${t.baseUrl}/${encodeURIComponent(n)}/fields`, { refreshTokenGuid: e }));
		return this.objectsAndFieldsSorter(r);
	}
	async objectRelationship(e, n, r) {
		let i = await this.api.get(this.buildPath(`${t.baseUrl}/${encodeURIComponent(n)}/${encodeURIComponent(r)}`, { refreshTokenGuid: e }));
		return {
			...i,
			fields: this.objectsAndFieldsSorter(i.fields)
		};
	}
	async object(e, n) {
		let r = await this.api.get(this.buildPath(`${t.baseUrl}/${encodeURIComponent(n)}`, { refreshTokenGuid: e }));
		return {
			...r,
			fields: this.objectsAndFieldsSorter(r.fields),
			relationships: this.relationShipSorter(r.relationships)
		};
	}
	objectsAndFieldsSorter(e) {
		return e.slice().sort((e, t) => Number(t.indexed) - Number(e.indexed) || e.label.localeCompare(t.label));
	}
	relationShipSorter(e) {
		return e.slice().sort((e, t) => e.relationshipName.localeCompare(t.relationshipName));
	}
};
//#endregion
export { t as SalesforceSourceConfigurationInternalResource };

//# sourceMappingURL=SalesforceSourceConfigurationInternalResource.js.map